import { storeOutboundEventBus } from "src/shared/data-loading/outbound/bus/storeOutboundEventBus";
import { storeInboundEventBus } from "src/shared/data-loading/inbound/bus/storeInboundEventBus";
import handleInitializeCampaign from "src/shared/data-loading/outbound/campaign/handlers/initialize_campaign";
import CampaignEndpoints from "src/shared/api/campaign/CampaignEndpoints";
import CampaignSummaryEndpoints from "src/shared/api/campaign/CampaignSummaryEndpoints";
import { once } from "lodash";
import { campaignInitTracker } from "./campaign/tracker";
export const setupFakeWebSocket = once(() => {
    // Register outbound event handlers
    storeOutboundEventBus.on("initialize_campaign", (payload) => {
        handleInitializeCampaign(payload, storeInboundEventBus, CampaignEndpoints, CampaignSummaryEndpoints);
    });
    // Set up campaign initialization lifecycle handler
    storeInboundEventBus.on("campaign_initialized", (payload) => {
        campaignInitTracker.markInitialized(payload.campaignId);
    });
});
